import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { StorageUrlService } from './services/storage-url.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'siq-adminapp';

  constructor(private authService: AuthService,
              private storageUrlService: StorageUrlService) {
    // Een teruggekeerde bezoeker heeft nog een geldig token in de opslag van
    // de browser, zonder zojuist te hebben ingelogd — dat is verder het
    // enige moment waarop iemand beeld te zien krijgt zonder dat
    // AuthService.bewaarSessie() net is gedraaid.
    if (this.authService.token) {
      this.storageUrlService.refresh();
    }
  }
}
